module.exports = __webpack_public_path__ + "static/HelveticaNeueLTW1G-Bd-06822daedae256c6a731cafda51e4bf1.woff2";